import { useForm, ValidationError } from '@formspree/react'
import { Breadcrumbs } from '../components/Breadcrumbs'
import { LINKS } from '../config/links'
import { Seo } from '../seo/Seo'
import { breadcrumbSchema } from '../seo/schema'
import './Contact.css'

const FORMSPREE_ID = 'mnpaaeey'

function ContactForm() {
  const [state, handleSubmit] = useForm(FORMSPREE_ID)

  if (state.succeeded) {
    return (
      <div className="contact__success" role="status">
        <p>Thank you</p>
        <span>Your message has been sent.</span>
      </div>
    )
  }

  return (
    <form className="contact__form" onSubmit={handleSubmit}>
      <div className="contact__row">
        <label>
          <span>Name</span>
          <input type="text" name="name" autoComplete="name" required />
          <ValidationError
            className="contact__field-error"
            prefix="Name"
            field="name"
            errors={state.errors}
          />
        </label>

        <label>
          <span>Email</span>
          <input type="email" name="email" autoComplete="email" required />
          <ValidationError
            className="contact__field-error"
            prefix="Email"
            field="email"
            errors={state.errors}
          />
        </label>
      </div>

      <label>
        <span>Topic</span>
        <select name="topic" defaultValue="Support">
          <option>Support</option>
          <option>Feedback</option>
          <option>Partnership</option>
          <option>Other</option>
        </select>
      </label>

      <label>
        <span>Message</span>
        <textarea name="message" rows={6} required />
        <ValidationError
          className="contact__field-error"
          prefix="Message"
          field="message"
          errors={state.errors}
        />
      </label>

      <ValidationError className="contact__field-error" errors={state.errors} />

      <button
        className="btn btn--primary contact__submit"
        type="submit"
        disabled={state.submitting}
      >
        {state.submitting ? 'Sending…' : 'Send message'}
      </button>
    </form>
  )
}

export function Contact() {
  return (
    <main className="contact shell">
      <Seo
        title="Contact"
        description="Contact Music24 support at support@music24.app for help with the Jewish music radio app and website."
        path="/contact"
        keywords={['music24 contact', 'music24 support', 'jewish radio support']}
        jsonLd={breadcrumbSchema([
          { name: 'Home', path: '/' },
          { name: 'Contact', path: '/contact' },
        ])}
      />
      <Breadcrumbs
        items={[
          { name: 'Home', path: '/' },
          { name: 'Contact' },
        ]}
      />

      <header className="contact__header">
        <h1>Contact</h1>
      </header>

      <div className="contact__layout">
        <section className="contact__form-card" aria-labelledby="contact-form-heading">
          <h2 id="contact-form-heading">Send a message</h2>
          <ContactForm />
        </section>

        <a className="contact__email" href={`mailto:${LINKS.supportEmail}`}>
          {LINKS.supportEmail}
        </a>
      </div>
    </main>
  )
}
